import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const FooterSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('footer');

    // Get the footer content data
    const footerData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <div>
                <div className="height-emulator d-none d-lg-block" />
                <footer className="footer-area footer-fixed">
                    <div className="footer-top ptb_100">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12">
                                    <LoadingSpinner size="lg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }

    if (isError) {
        return (
            <div>
                <div className="height-emulator d-none d-lg-block" />
                <footer className="footer-area footer-fixed">
                    <div className="footer-top ptb_100">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12">
                                    <ErrorMessage error={error} onRetry={() => loadContentBySection('footer')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }

    if (!footerData) {
        return (
            <div>
                <div className="height-emulator d-none d-lg-block" />
                <footer className="footer-area footer-fixed">
                    <div className="footer-top ptb_100">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12">
                                    <div className="text-center">
                                        <p>No footer content available.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }

    return (
        <div>
            <div className="height-emulator d-none d-lg-block" />
            <footer className="footer-area footer-fixed">
                {/* Footer Top */}
                <div className="footer-top ptb_100">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Logo */}
                                    <a className="navbar-brand" href="/#">
                                        <img className="logo" src={footerData.logo} alt="SalesPinch" />
                                    </a>
                                    <p className="mt-2 mb-3">{footerData.description}</p>
                                    {/* Social Icons */}
                                    <div className="social-icons d-flex">
                                        <a className="facebook" href="/#">
                                            <i className="fab fa-facebook-f" />
                                            <i className="fab fa-facebook-f" />
                                        </a>
                                        <a className="twitter" href="/#">
                                            <i className="fab fa-twitter" />
                                            <i className="fab fa-twitter" />
                                        </a>
                                        <a className="linkedin" href="/#">
                                            <i className="fab fa-linkedin-in" />
                                            <i className="fab fa-linkedin-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Footer Title */}
                                    <h3 className="footer-title mb-2">Company</h3>
                                    <ul>
                                        {footerData.footerLinks && footerData.footerLinks.company && footerData.footerLinks.company.map((item, idx) => (
                                            <li key={`flo_${idx}`} className="py-2">
                                                <a href={item.link}>{item.name}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Footer Title */}
                                    <h3 className="footer-title mb-2">Product</h3>
                                    <ul>
                                        {footerData.footerLinks && footerData.footerLinks.product && footerData.footerLinks.product.map((item, idx) => (
                                            <li key={`flt_${idx}`} className="py-2">
                                                <a href={item.link}>{item.name}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Footer Title */}
                                    <h3 className="footer-title mb-2">Support</h3>
                                    <ul>
                                        {footerData.footerLinks && footerData.footerLinks.support && footerData.footerLinks.support.map((item, idx) => (
                                            <li key={`flth_${idx}`} className="py-2">
                                                <a href={item.link}>{item.name}</a>
                                            </li>
                                        ))}
                                        <li className="py-2">
                                            <Link to="/data-deletion">Data Deletion Request</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                {/* Copyright Area */}
                                <div className="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                                    {/* Copyright Left */}
                                    <div className="copyright-center">{footerData.copyright}</div>
                                    {/* Copyright Right */}
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default FooterSection;